import {
    SET_HYBRID_DATA
} from '../actions/types';

const initialState = {
    hybridToSend: [],
}

export default (state = {...initialState}, { type , payload }) => {
    switch(type) {
        case SET_HYBRID_DATA: {
            let newState = {...state};
            newState.hybridToSend = payload.hybrid;
            return {
                ...newState
            }
        }
        default: {
            return {...state};
        }
    }
}